module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ListHeader', {
    attrs: {
      "title": "Eventos"
    }
  }), _vm._v(" "), _c('el-card', {
    staticClass: "el-card__save_form box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Dados do Evento")])]), _vm._v(" "), _c('event-basic-data', {
    attrs: {
      "event-id": _vm.eventId
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bd066580!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/event/components/Store.vue
// module id = 784
// module chunks = 2